import { Theme } from "types";

export const theme: Theme = {
  colors: {
    primary: "#333333",
    secondary: "#222222",
    tertiary: "#FE615E",
    background: "linear-gradient(135deg, #222222 0%, #333333 100%)",
    text: "#FE615E",
    textLight: "rgba(255, 255, 255, 0.8)",
  },
  spacing: {
    xs: "0.5rem",
    sm: "1rem",
    md: "1.5rem",
    lg: "2rem",
    xl: "3rem",
  },
  borderRadius: {
    sm: "8px",
    md: "16px",
    lg: "24px",
  },
  shadows: {
    sm: "0 2px 4px rgba(0, 0, 0, 0.1)",
    md: "0 4px 8px rgba(0, 0, 0, 0.1)",
    lg: "0 8px 16px rgba(0, 0, 0, 0.1)",
  },
};
